<template>
  <!-- <pre v-if="responseData"> testData={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/KPI.png"
        alt="KPI"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>

    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>
      </div>
      <h2>Laporan KPI JKT</h2>
      <div class="tindakan">
        <div
          v-for="(tindakan, index) in tindakanData"
          :key="index"
          class="tindakan-container"
        >
          <img
            src="@/assets/spah/box.png"
            :alt="tindakan.altText"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>{{ tindakan.title }}</h3>
              <p class="number">
                {{ tindakan.count }}
              </p>
            </div>
          </div>
        </div>
      </div>

      
        <button
        class="download-button"
        @click="downloadPdf"
        >
        Download 
        </button> 
     
      <Update />
    </div>

    <PrimaryModule />
    <KhidmatPengurusan />
  </AdminBackground>
</template>

<script setup>
import KhidmatPengurusan from '@/components/menu-items/section-menu/khidmat-pengurusan-menu.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'


const years = ref([2022, 2023, 2024, 2025, 2026])
const selectedYear = ref(2026)


definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})

// Function to download PDF file
const downloadPdf = () => {
  const link = document.createElement('a')

  link.href = '/jkt/SENARAI_KPI_JKT_TAHUN_2023.pdf' 
  link.download = 'SENARAI_KPI_JKT_TAHUN_2023.pdf'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// Reactive variables
const tindakanData = computed(() => {
  if (!responseData.value || responseData.value.length === 0) {
    return [
      { title: 'JUMLAH KPI', count: `0`, altText: 'First Image' },
      { title: 'SEKTOR PENGURUSAN DAN PEMBANGUNAN', count: `0`, altText: 'Second Image' },
      { title: 'SEKTOR PENGURUSAN DAN PERUNDANGAN', count: `0`, altText: 'Third Image' },
    ]
  }

  const data = responseData.value[0] // Assuming API returns an array
  
  return [
    { title: 'JUMLAH KPI', count: `${data.total_kpi}`, altText: 'First Image' },
    { title: 'SEKTOR PENGURUSAN DAN PEMBANGUNAN ', count: `${data.management_sector}`, altText: 'Second Image' },
    { title: 'SEKTOR PENGURUSAN DAN PERUNDANGAN', count: `${data.law_sector}`, altText: 'Third Image' },
  ]
})

const responseData = ref(null)


// Services
const { httpGet } = useHttpService()

async function loadDataFromApi(year) {
  try {
    const response = await fetch(`https://ejkt.kpkt.gov.my/eprofil/api/gate/management_kpis?year=${year}`)
    const apiResponse = await response.json()

    responseData.value = apiResponse.data?.data || [] 


  } catch (err) {
    console.error('loadDataFromApi failed:', err)
  }
}

// Watch for changes in selectedYear
watch(selectedYear, newYear => {
  loadDataFromApi(newYear) // Fetch data for the selected year
})

// Initial data load
onMounted(() => {
  loadDataFromApi(selectedYear.value)
})
</script>


<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; 
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
  text-transform: uppercase;
}

.tindakan {
  display: grid;
  grid-template-columns: repeat(3, 1fr); 
  grid-gap: 10px; 
}

.tindakan-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; 
}

.values-layered h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.download-button {
  background-color: #4285f4;
  color: white;
  padding: 5px;
  inline-size: 100px; 
  block-size: 50px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
  font-size: 15px;
}

.download-button:hover {
  background-color: #357ae8;
}



/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}


.input-item:last-child {
  margin-right: 0;
}


@media (max-width: 768px) {
  .tindakan {
    grid-template-columns: repeat(2, 1fr); 
  }

  h2 {
    font-size: 1.3rem; 
  }

  .download-button {
    inline-size: 120px;
    font-size: 14px; 
  }
}


@media (max-width: 480px) {
  .tindakan {
    grid-template-columns: 1fr; 
  }

  h2 {
    font-size: 1.2rem;
  }

  .values-layered h3 {
    font-size: 12px; 
  }

  .number {
    font-size: 20px; 
  }

  .download-button {
    inline-size: 100%;
    font-size: 14px;
    block-size: 45px;
  }
}
</style>
